import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import Head from 'components/head';
import Header from 'components/header';
import Footer from 'components/footer';
import GlobalStyle from 'global.css.js';
import { Location } from '@reach/router';
import { withResizeDetector } from 'react-resize-detector';
import BackToTop from '../back-to-top/back-to-top';
import useNewRelic from '../../helpers/newrelic';

const Layout = ({ children, data, meta }) => {
  useNewRelic();

  return (
    <div>
      <GlobalStyle />
      <Head {...meta} />
      <Location>
        {({ location }) => (
          <div>
            <Header
              selectedLanguage={
                location.pathname.split('/')[1] === '404'
                  ? data.site.siteMetadata.languages.defaultLangKey
                  : location.pathname.split('/')[1] ||
                    data.site.siteMetadata.languages.defaultLangKey
              }
              mainMenu={data.site.siteMetadata.mainMenu}
              title={data.headerJson.title}
            />
            <div className={'website-container'}>{children}</div>
            {location.pathname.split('/')[1] === '500' ? (
              ''
            ) : (
              <Footer
                selectedLanguage={
                  location.pathname.split('/')[1] === '404'
                    ? data.site.siteMetadata.languages.defaultLangKey
                    : location.pathname.split('/')[1] ||
                      data.site.siteMetadata.languages.defaultLangKey
                }
                footerMenu={data.site.siteMetadata.footerMenu}
                title={data.headerJson.title}
                facebook={data.footerJson.facebook}
                twitter={data.footerJson.twitter}
                youtube={data.footerJson.youtube}
                linkedin={data.footerJson.linkedin}
                informaUrl={data.footerJson.informaUrl}
                description={data.footerJson.description}
              />
            )}
            <BackToTop />
          </div>
        )}
      </Location>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  data: PropTypes.object.isRequired,
  width: PropTypes.any,
  meta: PropTypes.object,
};

const LayoutWithQuery = props => (
  <StaticQuery
    query={graphql`
      query LayoutQuery {
        site {
          siteMetadata {
            siteTitle
            mainMenu
            footerMenu
            languages {
              defaultLangKey
              langs
              defaultPageUrl
            }
          }
        }
        headerJson {
          title
        }
        footerJson {
          facebook
          twitter
          youtube
          linkedin
          informaUrl
          description
        }
      }
    `}
    render={data => <Layout data={data} {...props} />}
  />
);

LayoutWithQuery.propTypes = {
  children: PropTypes.node.isRequired,
  meta: PropTypes.object,
};

export default withResizeDetector(LayoutWithQuery);
